import { useState } from 'react'

import {
  EMPTY_FUNCTION,
  EMPTY_FUNCTION_ASYNC,
} from '../../../../constants/common'
import { UserProfileContextProvider } from '../../../User'
import { UserProfilePageHeader } from '../../../UserProfilePage'
import { Container } from '../../Container'

import { PROFILE_HEADER_USER_STAFF_VARIANTS } from './ProfileHeaderUserStaff.constants'

function ProfileHeaderStaffVariant({ staffData }) {
  const [modal, setModal] = useState(null)

  function handleCloseModal() {
    setModal(null)
  }

  return (
    <UserProfileContextProvider
      isInitiated
      handleCloseModal={handleCloseModal}
      handleEntityReload={EMPTY_FUNCTION_ASYNC}
      handleReloadTabs={EMPTY_FUNCTION_ASYNC}
      handleUpdateEntity={EMPTY_FUNCTION_ASYNC}
      isLoading={false}
      isPerformingAction={false}
      setModal={setModal}
      setPerformingAction={EMPTY_FUNCTION}
      userData={staffData}
    >
      <UserProfilePageHeader />
      {modal}
    </UserProfileContextProvider>
  )
}

function ProfileHeaderUserStaff() {
  return (
    <>
      {PROFILE_HEADER_USER_STAFF_VARIANTS.map(({ label, staffData }) => (
        <Container key={label} label={label}>
          <ProfileHeaderStaffVariant staffData={staffData} />
        </Container>
      ))}
    </>
  )
}

export default ProfileHeaderUserStaff
